module.exports = __webpack_public_path__ + "static/vanderlande-logo-538f3903d148ddb2e8d3e235cc5d1d99.jpg";